export const PackingEnforcementMode = {
  Enforced: 'Enforced',
  Warning: 'Warning',
  Advisory: 'Advisory',
} as const;

export type PackingEnforcementMode = (typeof PackingEnforcementMode)[keyof typeof PackingEnforcementMode];
